/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useMemo} from 'react'
import ReactApexChart from 'react-apexcharts'
import {Spinner} from 'react-bootstrap'
import {buildChartClickEvents, formatDurasiJam} from './chartPointClick'
import {ChartActiveFilterHeader} from './ChartActiveFilterHeader'

type DataPoint = number[]
type Label = string[]

type Props = {
  loading: boolean
  bulanAwal: string
  bulanAkhir: string
  tahunAwal: string
  tahunAkhir: string
  kota: string
  jenjang: string
  mitra: string
  className: string
  totalJam: number
  series: {
    name: string
    data: DataPoint
  }[]
  options: {
    chart: {
      height: 350
      type: 'area'
    }
    dataLabels: {
      enabled: false
    }
    stroke: {
      curve: 'smooth'
    }
    xaxis: {
      categories: Label
    }
    tooltip: {
      x: {
        // format: 'MM'
      }
    }
  }
  onPointClick?: (label: string, value: number, index: number) => void
}

const MixedWidget10: React.FC<Props> = ({
  className,
  series,
  options,
  totalJam,
  loading,
  kota,
  jenjang,
  mitra,
  bulanAwal,
  bulanAkhir,
  tahunAwal,
  tahunAkhir,
  onPointClick,
}) => {
  const chartOptions = useMemo(
    () => ({
      ...options,
      markers: {
        size: 5,
        hover: {
          size: 7,
        },
      },
      tooltip: {
        ...options.tooltip,
        intersect: true,
        shared: false,
      },
      chart: {
        ...options.chart,
        events: buildChartClickEvents(
          options.xaxis.categories,
          series[0]?.data,
          onPointClick
        ),
      },
    }),
    [options, series, onPointClick]
  )

  return (
    <div className={`card ${className} container`}>
      <div className='card-body d-flex flex-column p-0'>
        <div className='flex-grow-1 card-p pb-0'>
          <div className='d-flex flex-stack flex-wrap mb-5'>
            <div className='me-2'>
              <div className='text-dark text-hover-primary fw-bold fs-3'>Statistik Durasi Baca</div>
            </div>

            {loading ? (
              <Spinner animation='border' />
            ) : (
              <div className='fw-bold fs-3'>
                Total: {formatDurasiJam(totalJam)}
              </div>
            )}
          </div>

          <ChartActiveFilterHeader
            kota={kota}
            jenjang={jenjang}
            mitra={mitra}
            bulanAwal={bulanAwal}
            bulanAkhir={bulanAkhir}
            tahunAwal={tahunAwal}
            tahunAkhir={tahunAkhir}
          />

          <div className='mixed-widget-7-chart card-rounded-bottom'>
            {loading ? (
              <Spinner animation='border' />
            ) : (
              <ReactApexChart options={chartOptions} series={series} type='area' height={350} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export {MixedWidget10}
